<template>
    <div class="architecture">
        <!-- <div class="tac"><img src="/useful/logo2x.png" alt="" class="logo"></div> -->
        <template v-if="detail&&detail.length">
            <div class="archi_content mbj-archi_content" v-html="detail[0].richText">
            <!-- <img src="/img@2x.png" alt=""> -->
        </div>
        </template>
        <template v-else>
            <nothing></nothing>
        </template>
    </div>
</template>
<script>
import { getRich} from '~/until/http.js'
import nothing from '~/components/nothing.vue'
export default {
    data (){
        return {
            imgurl: this.$store.state.imgurl
        }
    },
    components:{
        nothing
    },
    async asyncData({isDev, route, store, env, params, query, req, res, redirect, error}) {
        let cont = await getRich(params.subid)
        return {
            detail: cont.content
        }
    },
    mounted(){
        getRich(this.$route.params.subid).then(res => {
            console.log(res)
            
        })

        //处理富文本中的图片
        // this.$nextTick(()=>{
        //     let imgarr = document.getElementsByClassName('archi_content')[0].getElementsByTagName('img')
        //     for(let i=0;i<imgarr.length;i++){
        //         let srcv = imgarr[i].src
        //         if(srcv.indexOf('app/fil') > -1){
        //             imgarr[i].src = this.imgurl + srcv.substring(srcv.indexOf('/app'))
        //         }

        //     }
        // })
    }
}
</script>
<style lang="scss">
.mbj-archi_content{
    color: #333;
    line-height: 25px;
    p{
        // text-indent: 2em;
    }
    div{
        // text-indent: 2em;
    }
    table{
        div,p{
            text-indent: 0.2em;
            word-break: break-all;
        }
    }
}
</style>
<style lang="scss" scoped>
.archi_content{
    padding-top: 12px;
}
.logo{
    width: 384px;
}
.architecture{
    padding: 20px 40px;
}
</style>